import { createSelector } from 'reselect';

import { selectEntitiesMissionsEntityOptInEnabled } from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { selectUserConnected } from '../../../../selectors/user/userPrimary.selector';
import { Selector } from '../../../../types/selectors';
import { selectUserMissionHasUserRegistered } from '../../selectors/userMissions';
import { MissionEnrollmentButtonStatuses, type MissionEnrollmentButtonStatus } from '../../types/components';

const selectMissionEnrollmentButtonStatus: Selector<MissionEnrollmentButtonStatus> = createSelector(
  [selectUserConnected, selectUserMissionHasUserRegistered, selectEntitiesMissionsEntityOptInEnabled],
  (isUserConnected, hasUserRegistered, optInRequired) => {
    if (isUserConnected) {
      if (optInRequired && !hasUserRegistered) {
        return MissionEnrollmentButtonStatuses.DEFAULT;
      }

      return MissionEnrollmentButtonStatuses.PASSIVE;
    }

    return MissionEnrollmentButtonStatuses.NOT_CONNECTED;
  },
);

type MissionEnrollmentButtonContainerPropsType = {
  status: MissionEnrollmentButtonStatus;
};

const selectMissionEnrollmentButtonContainerProps: Selector<MissionEnrollmentButtonContainerPropsType> = createSelector(
  [selectMissionEnrollmentButtonStatus],
  (status) => ({
    status,
  }),
);

export default selectMissionEnrollmentButtonContainerProps;
